import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-po-finish-prod-comps-b',
  templateUrl: './po-finish-prod-comps-b.component.html',
  styleUrls: ['./po-finish-prod-comps-b.component.css']
})
export class PoFinishProdCompsBComponent implements OnInit {
    p2PoFinishProdCompSbKeyno;

    public edit?: Edit;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.p2PoFinishProdCompSbKeyno = this.stateService.getStateParams()['p2_pofinishprodcompsb_keyno'];
    }

    private async loadEdit() {
        if (!!this.p2PoFinishProdCompSbKeyno) {
            this.edit = (await this.datatask.Post(173, { p2_pofinishprodcompsb_keyno: this.p2PoFinishProdCompSbKeyno }))[0];
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    await this.datatask.Post(174, { p2_pofinishprodcompsb_keyno: this.edit.p2_pofinishprodcompsb_keyno });

                    this.stateService.back();
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    p2_pofinishprodcompsb_keyno: string;
    p2_pofinishprodcomp_keyno: string;
    stockbatch_keyno: string;
    quantity: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('poFinishProdCompsB', {
//        templateUrl: 'views/components/views/poFinishProdCompsB/poFinishProdCompsB.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'poFinishProdCompsBService', function ($stateParams, stateService, translateService, modalService, poFinishProdCompsBService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let p2PoFinishProdCompSbKeyno = $stateParams.p2_pofinishprodcompsb_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                edit: {},
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATION FUNCTION

//            async function translate() {
//                let data = await translateService.translateBatch(translations);

//                Object.keys(translations).forEach((key) => {
//                    if (data?.[key]) translations[key] = data[key];
//                });
//            }

//            // #endregion TRANSLATION FUNCTION

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadEdit() {
//                vm.model.edit = (await poFinishProdCompsBService.getEdit({ p2_pofinishprodcompsb_keyno: p2PoFinishProdCompSbKeyno }))[0];
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(() => {
//                    poFinishProdCompsBService.deleteItem({ p2_pofinishprodcompsb_keyno: vm.model.edit.p2_pofinishprodcompsb_keyno }).then(() => {
//                        vm.model.lockedDelete = false;
//                        stateService.back();
//                    }, () => vm.model.lockedDelete = false);
//                }, () => vm.model.lockedDelete = false);
//            }

//            // #endregion BUTTON DELETE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                translate();
//                loadEdit();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
